// src/utils/firebase.js
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth"; // Importar getAuth

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC5HteikP2thL9DZa1u9dkBSsihRjhezQM",
  authDomain: "mariokarts-fee04.firebaseapp.com",
  projectId: "mariokarts-fee04",
  storageBucket: "mariokarts-fee04.firebasestorage.app",
  messagingSenderId: "280965911889",
  appId: "1:280965911889:web:6455331e645b2c9b3bef70",
  measurementId: "G-LMF509WFDX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const auth = getAuth(app); // Obtener la instancia de Auth

export { storage, auth }; // Exportar auth